<script>
    export let headline;
    export let subheadline;
</script>
<div>
    <h3>{headline}</h3>
    <p>{subheadline}</p>
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    h3 {
        text-align: center;
        color: var(--surface);
        font-family: var(--font-body);
    }

    p {
        text-align: center;
        color: var(--surface-50);
    }
</style>